const strapiRouteQueryParameters = {
  draftRoute: 'draft',
  slugParam: 'slug',
  secretParam: 'secret',
};

export default strapiRouteQueryParameters;
